/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Placeholders_Alipay_Test_AmountInputs */

const en_admin_settings_placeholders_alipay_test_amount = /** @type {(inputs: Admin_Settings_Placeholders_Alipay_Test_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty to use real amount, 1 = ¥0.01`)
};

const zh_admin_settings_placeholders_alipay_test_amount = /** @type {(inputs: Admin_Settings_Placeholders_Alipay_Test_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留空使用实际金额，填 1 则支付 ¥0.01`)
};

/**
* | output |
* | --- |
* | "Leave empty to use real amount, 1 = ¥0.01" |
*
* @param {Admin_Settings_Placeholders_Alipay_Test_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_placeholders_alipay_test_amount = /** @type {((inputs?: Admin_Settings_Placeholders_Alipay_Test_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Placeholders_Alipay_Test_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_placeholders_alipay_test_amount(inputs)
	return zh_admin_settings_placeholders_alipay_test_amount(inputs)
});
export { admin_settings_placeholders_alipay_test_amount as "admin.settings.placeholders.alipay_test_amount" }